module.exports = __webpack_public_path__ + "img/thumbnail@2x.5faedf65.jpg";